import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.listPOCustomFieldConfigs.pOCustomFieldConfigTable`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Purchase order custom fields',
  },
  columnFieldDescription: {
    id: `${scope}.columnFieldDescription`,
    defaultMessage: 'Field description',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'There are no custom PO fields',
  },
  deleteFieldButtonLabel: {
    id: `${scope}.deleteFieldButtonLabel`,
    defaultMessage: 'Delete field {name}',
  },
  deleteFieldButtonTitle: {
    id: `${scope}.deleteFieldButtonTitle`,
    defaultMessage: 'Delete field',
  },
})
